export const SET_DISABLE_SIDEBAR_COMMENTS = 'SET_DISABLE_SIDEBAR_COMMENTS';
export const UPDATE_SIDEBAR_STATE = 'UPDATE_SIDEBAR_STATE';

export const setDisableSidebarComments = (disableSidebarComments) => ({
  type: SET_DISABLE_SIDEBAR_COMMENTS,
  data: {
    disableSidebarComments,
  },
});

export const updateSidebarState = (sidebarState) => ({
  type: UPDATE_SIDEBAR_STATE,
  data: {
    sidebarState,
  },
});
